import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-piechart',
  templateUrl: './piechart.component.html',
  styleUrls: ['./piechart.component.css']
})
export class PiechartComponent implements OnInit {

  @Input() percEnergyNetCarbs: number;
  @Input() percEnergyProtein: number;
  @Input() percEnergyFat: number;


  public pieChartLabels: string[] = ['Węglowodany netto', 'Białko', 'Tłuszcz'];
  public pieChartData: number[] = [];
  public pieChartType: string = 'pie';
  public pieChartLegend: boolean = true;
  public pieChartColors = [
    {
      backgroundColor: ['rgba(245, 159, 181)', 'rgba(212, 250, 182)', 'rgba(193, 226, 247)'],
    },
  ];

  constructor() {
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

  ngOnInit(): void {
    this.pieChartData.push(this.percEnergyNetCarbs);
    this.pieChartData.push(this.percEnergyProtein);
    this.pieChartData.push(this.percEnergyFat);
  }
}
